import { useEffect } from 'react';
import { MEDIA_TIME_UPDATE, onEvent } from '@fec/assets/js/utils/event';
import DebounceHelper from '@fec/frontend/foundation/client/debounce-helper';
import {
  getMediumProgress,
  setMediumProgress,
} from '@fec/assets/js/utils/media-progress';

const MEDIA_PROGRESS_UPDATE_TIME = 1000;

/**
 * Does 2 things:
 * - gets the play progress in seconds for a specific piece of media (id'd by URN) from the local storage, if it exists
 * - saves the play progress for a specific piece of media (id's by URN) to the local storage upon event sent by player (see usePlayer.jsx)
 * @param urn
 * @param shouldSubscribeToTimeline
 * @returns {{lastPlayerSeek: Number|undefined}}
 */
const useMediaProgressStorage = ({ urn, shouldSubscribeToTimeline }) => {
  // maybe there's an entry in the local storage? Let's find out!
  const storedProgress = getMediumProgress(urn);

  useEffect(() => {
    if (shouldSubscribeToTimeline) {
      onEvent({
        eventName: MEDIA_TIME_UPDATE,
        eventHandler: DebounceHelper.throttle(({ detail }) => {
          const { urn: urnFromDetail, seconds, duration } = detail;
          if (urnFromDetail === urn) {
            // write progress to local storage
            setMediumProgress(urn, seconds, duration);
          }
        }, MEDIA_PROGRESS_UPDATE_TIME),
      });
    }
  }, [urn, shouldSubscribeToTimeline]);

  return { lastPlayerSeek: storedProgress?.seconds };
};

export default useMediaProgressStorage;
